import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "shortName",
    standalone: false
})
export class ShortNamePipe implements PipeTransform {
  transform(fullName: string): any {
    return fullName == undefined?fullName:fullName
      .split(" ")
      .map(n => n[0]==undefined?n[0]:n[0].toUpperCase())
      .join("");
  }
}